"use client";

import "./globals.css";
import { ErrorState } from "@/components/error-state";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <html lang="en"><body><ErrorState code="INTERNAL_SERVER_ERROR" onRetry={reset} reference={error.digest} /></body></html>;
}
